// ---- rendering: driven by the screen:state event (state = the POS's wsOrderData, null = nothing to show)
// The view renders .carousel-container, the stylesheet still says .carousel-contanier: target both.
const CAROUSEL_SELECTOR = '.carousel-container, .carousel-contanier';

function hasScreenContent(state) {
  if (!state || typeof state !== 'object') return false;
  return (
    (Array.isArray(state.share_by_amount) &&
      state.share_by_amount.length > 0) ||
    Number(state.exchange_amount) > 0 ||
    (Array.isArray(state.products) && state.products.length > 0)
  );
}

// Back to the idle carousel: cart empty, order completed or cancelled
function resetCustomerScreen() {
  $('.confirmation-toast').remove();
  $('.customer-screen-checkout').empty();
  $('.checkout-screen-container').addClass('d-none').removeClass('w-50 w-100');
  $(CAROUSEL_SELECTOR)
    .removeClass('d-none w-50')
    .addClass('w-100')
    .css('padding-right', '0');
  $('.customer-screen-summary').removeClass('d-none');
  $('#discount-percent').text('0');
  $('#total-price').text('');
  $('#total-discount-price').text('0');
}

function renderCustomerScreen(state) {
  if (hasScreenContent(state)) updateCustomerScreen(state);
  else resetCustomerScreen();
}

function updateCustomerScreen(data) {
  if ($('.customer-screen-view-container').hasClass('mobile')) {
    $(CAROUSEL_SELECTOR).addClass('d-none');
    $('.checkout-screen-container').removeClass('d-none').addClass('w-100');
  } else {
    $(CAROUSEL_SELECTOR)
      .removeClass('w-100')
      .addClass('w-50')
      .css('padding-right', '16px');
    $('.checkout-screen-container').removeClass('d-none').addClass('w-50');
  }
  const $checkout = $('.customer-screen-checkout');
  $checkout.empty();

  if (data.share_by_amount && data.share_by_amount.length > 0) {
    const shareByAmountOrder = data.share_by_amount[0];
    const tableName = decodeHtml(shareByAmountOrder.table_name);
    const personName = decodeHtml(shareByAmountOrder.person_name);
    const amount = formattedPriceToShow(shareByAmountOrder.amount);

    const amountCard = `
      <div class="amount-card">
        <div class="ac-label">
          Betalende person: <span class="ac-name">${personName}</span>
        </div>
        <div class="ac-label">
          Bordnummer: <span class="ac-name">${tableName}</span>
        </div>
        <div class="ac-amount">
          ${amount}<span class="ac-currency">kr</span>
        </div>
      </div>`;
    $checkout.append(amountCard);

    $('.customer-screen-summary').addClass('d-none');
  } else if (data.exchange_amount && data.exchange_amount > 0) {
    const exchangeAmount = formattedPriceToShow(data.exchange_amount);

    const exchangeAmountCard = `
      <div class="amount-card">
        <div class="ac-label">
          Vekslebeløp
        </div>
        <div class="ac-amount">
          ${exchangeAmount}<span class="ac-currency">kr</span></span>
        </div>
      </div>`;
    $checkout.append(exchangeAmountCard);

    $('.customer-screen-summary').addClass('d-none');
  } else if (Array.isArray(data.products)) {
    $.each(data.products, function (index, product) {
      const productPrice =
        parseFloat(product.price) *
        (1 - parseFloat(product.discount_percent) / 100);

      const mainDiv = $('<div>').addClass('product-detail');
      const productDetailsDiv = $('<div>')
        .addClass('product-name')
        .text(
          `${formattedPriceToShow(product.quantity)} x ${decodeHtml(product.name)}${
            parseFloat(product.discount_percent) > 0
              ? ` (${product.discount_percent}%)`
              : ''
          }`
        );

      if (product.product_extra) {
        $.each(product.product_extra, function (i, extra) {
          const extraDiv = $('<div>').addClass('extra-item w-100 pl-4');
          const extraDetailsDiv = $('<div>')
            .addClass('product-name')
            .text(`- ${decodeHtml(extra.extra_name)} x ${extra.amount}`);

          extraDiv.append(extraDetailsDiv);
          productDetailsDiv.append(extraDiv);
        });
      }
      const priceDiv = $('<div>')
        .addClass('product-price')
        .text(`${formattedPriceToShow(productPrice)} kr`);

      mainDiv.append(productDetailsDiv).append(priceDiv);

      $checkout.append(mainDiv);
    });

    const totalPrice = parseFloat(data.total);
    const totalDiscountPrice = parseFloat(data.total_with_discount);

    $('.customer-screen-summary').removeClass('d-none');
    $('#discount-percent').text(
      ` ${formattedPriceToShow(data.discount_percent)} %`
    );
    $('#total-price').text(` ${formattedPriceToShow(totalPrice)} kr`);
    $('#total-discount-price').text(
      ` ${formattedPriceToShow(totalDiscountPrice)} kr`
    );
  }
}

$(document).ready(function () {
  let p = $('body').attr('p');
  deviceId = $('body').attr('deviceid');
  let locationId = $('body').attr('location_id');
  const organizerId = $('body').attr('organizer_id');

  if (p == 'customer_screen') {
    $('header').hide();

    const regexp = /^[A-Za-z0-9_-]{32,64}$/;
    if (regexp.test(deviceId)) {
      SocketHub.initScreen({ screenId: deviceId, organizerId });

      // fired after every (re)connect with the server's last state, and on each POS publish
      $(document).on('screen:state', function (e, s) {
        renderCustomerScreen(s.state);
      });
      $(document).on('screen:pos', function (e, p) {
        console.log('[screen] POS online:', p.online);
      });
      console.log(
        'connected',
        SocketHub.customerScreen.connected(),
        'posOnline',
        SocketHub.customerScreen.posOnline()
      );
    }

    $(document).on('submit', '#device-id-form', function (e) {
      e.preventDefault();
      const POSDeviceId = $('#pos-device-id').val();
      const locationId = $('#location-id').val();

      const customerScreenUrl =
        window.location.pathname + '?deviceId=' + POSDeviceId;
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            action: 'save_customer_screen_url',
            data: customerScreenUrl,
          })
        );
      }

      window.location.href = customerScreenUrl;
    });

    let tapCount = 0;
    let tapTimer = null;
    let lastTouchTime = 0;
    const MAX_DELAY = 800; // ms allowed between taps
    const TOUCH_CLICK_GAP = 500; // ms window to ignore synthetic click after touch

    function registerTap() {
      tapCount++;

      clearTimeout(tapTimer);
      tapTimer = setTimeout(function () {
        tapCount = 0;
      }, MAX_DELAY);

      if (tapCount === 5) {
        clearTimeout(tapTimer);
        tapCount = 0;

        console.log('5 continuous taps/clicks detected!');
        $('#exit-customer-screen-modal').modal('show');
      }
    }

    $(document).on('touchstart', function () {
      lastTouchTime = Date.now();
      registerTap();
    });

    $(document).on('click', function () {
      if (Date.now() - lastTouchTime < TOUCH_CLICK_GAP) {
        return;
      }
      registerTap();
    });

    $(document).on('click', '#confirm-exit-customer-screen-btn', function () {
      $('#exit-customer-screen-modal').modal('hide');
      const dashboardUrl = $('.navbar-brand').attr('data-single-tap-href');

      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            action: 'remove_customer_screen_url',
          })
        );
      }

      window.location.href = dashboardUrl;
    });
  }
});
